
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/til-limited",
      function () {
        return require("private-next-pages/case-study/til-limited.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/til-limited"])
      });
    }
  